//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
SPLM.Annotations.LineCfw = class{
    constructor(color,font,width){
        this.color=color;this.font=font;this.width=width;}
    get Color(){return this.color}
    set Color(val){this.color = val}
    get Font(){return this.font}
    set Font(val){this.font = val}
    get Width(){return this.width}
    set Width(val){this.width = val}
};

SPLM.Annotations.TextCfw = class{
    constructor(color,font,width){
        this.color=color;this.font=font;this.width=width;}
    get Color(){return this.color}
    set Color(val){this.color = val}
    get Font(){return this.font}
    set Font(val){this.font = val}
    get Width(){return this.width}
    set Width(val){this.width = val}
};

SPLM.Annotations.Lettering = class{
    constructor(size,character_space_factor,aspect_ratio,line_space_factor,cfw,italic,symbol_aspect_ratio){
        this.size=size;this.character_space_factor=character_space_factor;this.aspect_ratio=aspect_ratio;this.line_space_factor=line_space_factor;this.cfw=cfw;this.italic=italic;this.symbol_aspect_ratio=symbol_aspect_ratio;}
    get Size(){return this.size}
    set Size(val){this.size = val}
    get CharacterSpaceFactor(){return this.character_space_factor}
    set CharacterSpaceFactor(val){this.character_space_factor = val}
    get AspectRatio(){return this.aspect_ratio}
    set AspectRatio(val){this.aspect_ratio = val}
    get LineSpaceFactor(){return this.line_space_factor}
    set LineSpaceFactor(val){this.line_space_factor = val}
    get Cfw(){if(this.cfw === undefined) this.cfw = new SPLM.Annotations.TextCfw(); return this.cfw}
    set Cfw(val){this.cfw = val}
    get Italic(){return this.italic}
    set Italic(val){this.italic = val}
    get SymbolAspectRatio(){return this.symbol_aspect_ratio}
    set SymbolAspectRatio(val){this.symbol_aspect_ratio = val}
};

SPLM.Annotations.Value = class{
    constructor(item_value,value_expression,value_precision){
        this.item_value=item_value;this.value_expression=value_expression;this.value_precision=value_precision;}
    get ItemValue(){return this.item_value}
    set ItemValue(val){this.item_value = val}
    get ValueExpression(){return this.value_expression}
    set ValueExpression(val){this.value_expression = val}
    get ValuePrecision(){return this.value_precision}
    set ValuePrecision(val){this.value_precision = val}
};

SPLM.Annotations.CharacterSpaceFactor = class{
    constructor(general,dimension,tolerance,appended){
        this.general=general;this.dimension=dimension;this.tolerance=tolerance;this.appended=appended;}
    get General(){return this.general}
    set General(val){this.general = val}
    get Dimension(){return this.dimension}
    set Dimension(val){this.dimension = val}
    get Tolerance(){return this.tolerance}
    set Tolerance(val){this.tolerance = val}
    get Appended(){return this.appended}
    set Appended(val){this.appended = val}
};

SPLM.Annotations.TextJustification = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right"});

SPLM.Annotations.VerticalTextJustification = Object.freeze({
    "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom"});

SPLM.Annotations.AlignmentPosition = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MidLeft" : "MidLeft", "MidCenter" : "MidCenter", "MidRight" : "MidRight", "BottomLeft" : "BottomLeft", "BottomCeneter" : "BottomCeneter", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

SPLM.Annotations.StackAlignmentPosition = Object.freeze({
    "Above" : "Above", "Below" : "Below", "Left" : "Left", "Right" : "Right"});

SPLM.Annotations.Constants = Object.freeze({
    "MaxLeaders" : "MaxLeaders", "MaxLeaderIntermediatePoints" : "MaxLeaderIntermediatePoints"});

SPLM.Annotations.LeaderType = Object.freeze({
    "Null" : "Null", "Plain" : "Plain", "Around" : "Around", "PlainAligned" : "PlainAligned", "AroundAligned" : "AroundAligned", "Extension" : "Extension", "DatumArrow" : "DatumArrow", "DatumExt" : "DatumExt", "DatumDim" : "DatumDim", "GbDatumArrow" : "GbDatumArrow", "GbDatumExt" : "GbDatumExt", "GbDatumDim" : "GbDatumDim", "OnAnnotation" : "OnAnnotation", "OnStub" : "OnStub", "PlainNostub" : "PlainNostub", "AlignedNostub" : "AlignedNostub", "OnCenterline" : "OnCenterline", "DatumOnDotTerminatedLeader" : "DatumOnDotTerminatedLeader", "IdExtension" : "IdExtension", "LinearExtension" : "LinearExtension", "LinearIdExtension" : "LinearIdExtension", "AllOver" : "AllOver", "Last" : "Last"});

SPLM.Annotations.LeaderAttachment = Object.freeze({
    "Null" : "Null", "OnObject" : "OnObject", "Screen" : "Screen", "Last" : "Last"});

SPLM.Annotations.LeaderSide = Object.freeze({
    "Null" : "Null", "Left" : "Left", "Right" : "Right", "Inferred" : "Inferred", "Last" : "Last"});

SPLM.Annotations.LeaderAlignment = Object.freeze({
    "Null" : "Null", "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom", "TextBottomMax" : "TextBottomMax", "TextBottomMaxUnderline" : "TextBottomMaxUnderline", "TextBottom" : "TextBottom", "TextBottomUnderline" : "TextBottomUnderline", "TextTopMax" : "TextTopMax", "TextTopMaxUnderline" : "TextTopMaxUnderline", "TextTop" : "TextTop", "TextTopUnderline" : "TextTopUnderline", "Last" : "Last"});

SPLM.Annotations.LeaderOrientation = Object.freeze({
    "FromLeft" : "FromLeft", "FromRight" : "FromRight", "FromTop" : "FromTop", "FromBottom" : "FromBottom", "Inferred" : "Inferred"});

SPLM.Annotations.ArrowheadType = Object.freeze({
    "FilledDatumArrow" : "FilledDatumArrow", "FilledDot" : "FilledDot", "FilledArrow" : "FilledArrow", "ClosedArrow" : "ClosedArrow", "OpenArrow" : "OpenArrow", "CrossArrow" : "CrossArrow", "DotArrow" : "DotArrow", "OriginSymbolArrow" : "OriginSymbolArrow", "NoArrow" : "NoArrow", "UnfilledDatumArrow" : "UnfilledDatumArrow", "ClosedSolidArrow" : "ClosedSolidArrow", "ClosedDoubleArrow" : "ClosedDoubleArrow", "ClosedDoubleSolidArrow" : "ClosedDoubleSolidArrow", "OpenDoubleArrow" : "OpenDoubleArrow", "IntegralArrow" : "IntegralArrow", "BoxArrow" : "BoxArrow", "FilledBox" : "FilledBox", "FilledDoubleArrow" : "FilledDoubleArrow", "TopOpenArrow" : "TopOpenArrow", "BottomOpenArrow" : "BottomOpenArrow", "TopFilledArrow" : "TopFilledArrow", "BottomFilledArrow" : "BottomFilledArrow"});

SPLM.Annotations.AssociativeOriginType = Object.freeze({
    "Drag" : "Drag", "RelativeToView" : "RelativeToView", "RelativeToGeometry" : "RelativeToGeometry", "VerticallyAligned" : "VerticallyAligned", "HorizontallyAligned" : "HorizontallyAligned", "AlignedWithArrows" : "AlignedWithArrows", "AtAPoint" : "AtAPoint", "OffsetFromText" : "OffsetFromText", "AttachedToStack" : "AttachedToStack"});

SPLM.Annotations.LineWidth = Object.freeze({
    "Normal" : "Normal", "Thick" : "Thick", "Thin" : "Thin", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

SPLM.Annotations.PmiDefaultPlane = Object.freeze({
    "XyOfWcs" : "XyOfWcs", "ModelView" : "ModelView", "XzOfWcs" : "XzOfWcs", "YzOfWcs" : "YzOfWcs", "Last" : "Last"});

SPLM.Annotations.AssociativityPointOption = Object.freeze({
    "None" : "None", "Control" : "Control", "ArcCenter" : "ArcCenter", "Tangent" : "Tangent", "Intersection" : "Intersection", "ScreenPosition" : "ScreenPosition", "OnCurve" : "OnCurve", "Pole" : "Pole", "Anchor" : "Anchor", "Defining" : "Defining", "Last" : "Last"});

SPLM.Annotations.AssociativityLineOption = Object.freeze({
    "None" : "None", "ExistingLine" : "ExistingLine", "PointVector" : "PointVector", "ExtensionLine" : "ExtensionLine", "Centerline" : "Centerline", "Angle" : "Angle", "HorizontalRight" : "HorizontalRight", "VerticalUp" : "VerticalUp", "HorizontalLeft" : "HorizontalLeft", "VerticalDown" : "VerticalDown", "BaseLine" : "BaseLine", "Last" : "Last"});

SPLM.Annotations.StackVerticalAlignment = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right"});

SPLM.Annotations.StackHorizontalAlignment = Object.freeze({
    "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom"});

SPLM.Annotations.AreaFillMaterial = Object.freeze({
    "CorkFelt" : "CorkFelt", "SoundInsulation" : "SoundInsulation", "Concrete" : "Concrete", "Earth" : "Earth", "Rock" : "Rock", "Sand" : "Sand", "Liquids" : "Liquids", "WoodAcrossGrain" : "WoodAcrossGrain", "WoodAlongGrain" : "WoodAlongGrain", "SolidFill" : "SolidFill"});

SPLM.Annotations.SurfaceFinishStandard = Object.freeze({
    "Ansi" : "Ansi", "Iso" : "Iso", "Jis" : "Jis", "Din" : "Din", "Iso2002" : "Iso2002", "Din2002" : "Din2002", "Gb" : "Gb", "Eskd" : "Eskd", "Iso2021" : "Iso2021", "Iso25178" : "Iso25178"});

SPLM.Annotations.PmiResizeMethod = Object.freeze({
    "ViewScale" : "ViewScale", "ZoomFactor" : "ZoomFactor", "Independent" : "Independent", "PartPreferences" : "PartPreferences"});

SPLM.Annotations.FrameBarElements = Object.freeze({
    "AftPerpendicular" : "AftPerpendicular", "ForwardPerpendicular" : "ForwardPerpendicular", "CenterlineY" : "CenterlineY", "Baseline" : "Baseline", "Waterline" : "Waterline", "TransversalInsertArea" : "TransversalInsertArea", "BulkHeads" : "BulkHeads", "Decks" : "Decks", "TransverseFrames" : "TransverseFrames", "InterTransverseFrames" : "InterTransverseFrames", "LongitudinalYFrames" : "LongitudinalYFrames", "LongitudinalZFrames" : "LongitudinalZFrames", "AlongHullBaseline" : "AlongHullBaseline", "AlongHullWaterline" : "AlongHullWaterline", "AlongHullDecks" : "AlongHullDecks", "AlongHullLongitudinalZFrames" : "AlongHullLongitudinalZFrames", "LongitudinalBulkHeads" : "LongitudinalBulkHeads", "LongitudinalYInsertFrames" : "LongitudinalYInsertFrames", "LongitudinalZInsertFrames" : "LongitudinalZInsertFrames", "AlongHullLongitudinalZInsertFrames" : "AlongHullLongitudinalZInsertFrames", "Midship" : "Midship", "Num" : "Num"});

SPLM.Annotations.DisplayPmiEffectivityMethod = Object.freeze({
    "AllAssocOccLoaded" : "AllAssocOccLoaded", "AnyAssocOccLoaded" : "AnyAssocOccLoaded"});

SPLM.Annotations.JogOrientation = Object.freeze({
    "JogIn" : "JogIn", "JogOut" : "JogOut"});

SPLM.Annotations.LeaderVerticalAttachment = Object.freeze({
    "Null" : "Null", "Top" : "Top", "Center" : "Center", "Bottom" : "Bottom", "Legacy" : "Legacy", "Last" : "Last"});

SPLM.Annotations.StubSymbolType = Object.freeze({
    "None" : "None", "AllAround" : "AllAround", "AllOver" : "AllOver"});

SPLM.Annotations.BalloonTypes = Object.freeze({
    "Circle" : "Circle", "DividedCircle" : "DividedCircle", "TriangleDown" : "TriangleDown", "TriangleUp" : "TriangleUp", "Square" : "Square", "DividedSquare" : "DividedSquare", "Hexagon" : "Hexagon", "DividedHexagon" : "DividedHexagon", "QuadrantCircle" : "QuadrantCircle", "RoundedBox" : "RoundedBox", "Underline" : "Underline", "Nosymbol" : "Nosymbol"});

export default SPLM;